import { dateFormat, formatDate, microToDollars } from "helpers";
import { CAMPAIGN_PAGE_QUERY_PARAMS } from "model/campaigns";
import { AppNotificationLink } from "./AppNotificationLink";
import { NotificationReason } from "./types";

const LineitemLink = ({ lineitemName, campaignId }) => (
  <AppNotificationLink
    to={`/campaign/${campaignId}?${CAMPAIGN_PAGE_QUERY_PARAMS.lineitemSearchTerm}=${lineitemName}`}
    label={lineitemName}
  />
);

export const CampaignLink = ({ campaignId, campaignName }) => (
  <AppNotificationLink
    to={`/campaign/${campaignId}`}
    label={campaignName}
  />
);

export const NOTIFICATIONS_TITLE = {
  [NotificationReason.lineitemEndsIn3days]: () => <div>Line item ending</div>,
  [NotificationReason.campaignEndsIn3days]: () => <div>Campaign ending</div>,
  [NotificationReason.lineitemSpendOver90]: () => (
    <div>Line item low budget</div>
  ),
  [NotificationReason.campaignSpendOver90]: () => (
    <div>Campaign low budget</div>
  ),
  [NotificationReason.campaignRejectedInstallsHigh]: () => (
    <div>Rejected installs</div>
  ),
  [NotificationReason.campaignBudgetSpendOver90]: () => (
    <div>Campaign low budget</div>
  ),
};

export const NOTIFICATIONS_TEXT = {
  [NotificationReason.lineitemEndsIn3days]: ({
    campaignId,
    campaignName,
    lineitemName,
  }) => (
    <div>
      Line item{" "}
      <LineitemLink
        lineitemName={lineitemName}
        campaignId={campaignId}
      />{" "}
      in campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      ends in less than 3 days
    </div>
  ),
  [NotificationReason.campaignEndsIn3days]: ({ campaignId, campaignName }) => (
    <div>
      Campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      ends in less than 3 days
    </div>
  ),
  [NotificationReason.lineitemSpendOver90]: ({
    campaignId,
    campaignName,
    lineitemName,
  }) => (
    <div>
      Line item{" "}
      <LineitemLink
        lineitemName={lineitemName}
        campaignId={campaignId}
      />{" "}
      in campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      has less than 10% budget remaining
    </div>
  ),
  [NotificationReason.campaignSpendOver90]: ({ campaignId, campaignName }) => (
    <div>
      Campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      has less than 10% budget remaining
    </div>
  ),
  [NotificationReason.campaignRejectedInstallsHigh]: ({
    campaignId,
    campaignName,
    rejectedInstalls,
  }) => (
    <div>
      {rejectedInstalls} rejected installs received from campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      in last 24h.
    </div>
  ),
  [NotificationReason.campaignBudgetSpendOver90]: ({
    campaignId,
    campaignName,
    budget,
  }) => (
    <div>
      Campaign{" "}
      <CampaignLink
        campaignId={campaignId}
        campaignName={campaignName}
      />{" "}
      has less than 10% from ${microToDollars(budget.budget || 0)} (
      {formatDate(new Date(budget.start), dateFormat)} to{" "}
      {formatDate(new Date(budget.finish), dateFormat)}) budget
    </div>
  ),
};
